import { type FC } from "react";

import styled from "@emotion/styled";
import { type TooltipContentProps } from "recharts";

const Container = styled.span`
    text-transform: capitalize;
`;

export const AgeTooltipMetricValue: FC<{ name: TooltipContentProps["payload"][number]["name"]; value: string }> = ({
    name,
    value,
}) => (
    <Container>
        {name}: {value}
    </Container>
);
